import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './SendStage.css';
import Btn from '../../button/btn/Btn';

const SendStage = ({suspendedOrders, onClose}: {suspendedOrders: number; onClose: () => void;}) => {
    const {t} = useTranslation('suspendedConfirmation');
    
    return (
        <css.body>
            <css.text>{t('confirmationSentText', {number: suspendedOrders})}</css.text>
            <css.buttonContainer>
                <Btn onClick={onClose}>{t('close')}</Btn>
            </css.buttonContainer>
        </css.body>
    );
};

export default SendStage;
